import { FaEdit, FaPlus } from "react-icons/fa";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { useAddCurrency, useCurrenciesList } from "./hook/useSuperSetting";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { useState } from "react";
import LeaveTypeModal from "../../leave/components/LeaveTypeModal";
import CurrencyModalContent from "../ModalContent/CurrencyModalContent";

const CurrencyTable = () => {
  const [currencyModal, setCurrencyModal] = useState(false);
  const [currencyModalStatus, setCurrencyModalStatus] = useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const { data: currenciesData } = useCurrenciesList({
    enable: true,
    params: { search: "", page: "", per_page: "" },
  });

  const handleEdit = (row: any) => {
    console.log("🚀 ~ CurrencyTable.tsx:15 ~ handleEdit ~ row:", row);
    setCurrencyModalStatus("Edit");
    setCurrencyModal(!currencyModal);
    setSelectedRowData(row);
  };

  const toggleModal = () => {
    setCurrencyModal(false);
  };

  const handleAdd = () => {
    setCurrencyModal(!currencyModal);
  };

  return (
    <div className="container mt-3">
  
      <BasicDataTable
        Title="Currency"
        data={currenciesData?.data?.data || []}
        columns={BranchHqDataColumns(handleEdit)}
        search={true}
        headerContent={
          <button
            onClick={handleAdd}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaPlus /> <span>Add Role</span>
          </button>
        }
      />
      <RouteModal
        isOpen={currencyModal}
        toggle={toggleModal}
        title={
          currencyModalStatus === "Edit" ? "Edit Currency" : "Add Currency"
        }
        size="md"
        content={
          <>
            <CurrencyModalContent
              setCurrencyModal={setCurrencyModal}
              currencyModal={currencyModal}
              setCurrencyModalStatus={setCurrencyModalStatus}
              currencyModalStatus={currencyModalStatus}
              selectedRowData={selectedRowData}
              setSelectedRowData={setSelectedRowData}
            />
          </>
        }
      />
    </div>
  );
};

export default CurrencyTable;

const BranchHqDataColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Currency Name",
    selector: (row: { Name: string }) => row.Name || "-",
    sortable: true,
  },
  {
    name: "Short Code",
    selector: (row: { Shortcode: string }) => row.Shortcode || "-",
    sortable: true,
  },
  {
    name: "Action",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

// <LeaveTypeModal
//   handleSubmit={handleSubmit}
//   leaveType={leaveType}
//   setLeaveType={setLeaveType}
//   shortCode={shortCode}
//   setShortCode={setShortCode}
//   handleClose={handleClose}
//   updateForm={updateForm}
//   buttonDisable={buttonDisable}
// />
